module.exports = __webpack_public_path__ + "img/new_spotd11.b008117b.gif";